export default "__VITE_ASSET__B4wU9DCi__"